export const ROOT = '/';
export const DASHBOARD = '/dashboard';
export const DASHBOARD_OVERVIEW = '/dashboard';
export const DASHBOARD_LOOKS = '/dashboard/looks';
export const DASHBOARD_PRODUCTS = '/dashboard/products';
export const DASHBOARD_ORDERS = '/dashboard/orders';
export const BRAND_MANAGER = '/brand-manager';
export const BRAND_INFORMATION = '/brand-manager/brand-information';
export const BRAND_ADMIN_USER = '/brand-manager/brand-admin-user';
export const BANNERS = '/banners';
export const VIDEOS = '/videos';
export const ONBOARDING = '/onboarding';
export const PRODUCTS = '/products';
export const PARENT_PRODUCTS = '/parent_products';
export const CHILD_PRODUCTS = '/child_products';
export const COLORS = '/colors';
export const SIZES = '/sizes';
export const CATEGORIES = '/categories';
export const INVENTORIES = '/inventories';
export const CREATE_PRODUCT = '/products/create';
export const PRODUCTS_GROUPS = '/products-groups';
export const RETAILERS = '/retailers';
export const STORE = '/store';
export const STORE_MODULE_CREATE = '/store/modules/create';
export const STORE_MODULE_EDIT = '/store/modules/edit/:moduleUid';
export const LOCATION_MODULE_CREATE = '/locations/:locationUid/modules/create';
export const LOCATION_MODULE_EDIT = '/locations/:locationUid/modules/edit/:moduleUid';
export const RETAILER_LOCATION_MODULE_CREATE = '/retailer-locations/:locationUid/modules/create';
export const RETAILER_LOCATION_MODULE_EDIT =
  '/retailer-locations/:locationUid/modules/edit/:moduleUid';
export const REGIONS = '/region';
export const REGION = '/region';
export const REGION_INFO = '/region/region-info';
export const REGION_INTEGRATIONS = '/region/integrations';
export const REGION_SUBSCRIPTION_PLANS = '/region/subscription-plans';
export const REGION_CHECKOUT_CONFIG = '/region/checkout-config';
export const REGION_DEFAULT_LOOK_IMAGE = '/region/default-look-image';
export const REGION_HOW_TO_HUB = '/region/how-to-hub';
export const REGION_PAGE_MODULES = '/region/page-modules';
export const REGION_PAGE_MODULE_CREATE = '/region/page-modules/create';
export const REGION_PAGE_MODULE_EDIT = '/region/page-modules/edit/:moduleUid';
export const THEME_CUSTOMIZATION = '/brand-manager/theme-customization';
export const TIERS = '/tiers';
export const BRAND = '/brands';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const REGISTER_APPROVAL = '/register-approval/:uid';
export const ACTIVATE_ACCOUNT = '/activate-account';
export const RETAILER = '/retailers/:id';
export const RETAILER_DETAIL_LOOKS = '/retailers/:id/looks';
export const RETAILER_DETAIL_PRODUCTS = '/retailers/:id/products';
export const FORGOT_PASSWORD = '/forgot-password';
export const PROFILE = '/profile';
export const REGION_LOOKS = '/region-looks';
export const RETAILER_LOOKS = '/retailer-looks';
export const REGION_LOOK_EDIT = '/region-look/:id';
export const LOOK_EDIT = '/retailer-looks/:id';
export const WIDGETS = '/widgets';
export const WIDGET_SHOPIFY_GUIDE = '/widgets/shopify-guide';
export const WIDGET_CREATE = '/widgets/create';
export const WIDGET_EDIT = '/widgets/:id';
export const FAVORITE_PRODUCTS = '/favorite-products';
export const HOW_TO_HUB = '/how-to-hub';
export const HOW_TO_HUB_RETAILER = '/how-to-hub-retailer';
export const EVENTS = '/events';
export const RETAILER_LOCATIONS = '/retailer-locations';
export const LOCATIONS = '/locations';
export const RETAILER_LOCATION = '/retailer-locations/:uid';
export const LOCATION = '/locations/:uid';
export const LOCATION_GROUPS = '/location-groups';
export const LOCATION_GROUP = '/location-groups/:id';
export const RETAILER_LOCATION_GROUPS = '/retailer-location-groups';
export const RETAILER_LOCATION_GROUP = '/retailer-location-groups/:id';
export const ORDERS = '/orders';
export const ORDER = '/orders/:uid';
export const RETAILER_SALES = '/retailer-sales';
export const SUPER_USER = '/super-user';
export const SUPER_USER_ORDERS = '/super-user/orders';
export const SUPER_USER_TIERS = '/super-user/tiers';
export const SUPER_USER_REGIONS = '/super-user/regions';
export const SUPER_USER_REGION_DETAIL = '/super-user/regions/:uid';
export const SUPER_USER_ACCESS = '/super-user/access';
export const SUPER_USER_IMPERSONATION = '/super-user/impersonation';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const PRIVACY_POLICY = '/privacy-policy';
